import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { doSignInCompany } from "../../../modules/auth/stores/thunk";
import "./Auth.scss";

const SignInCompaniesForm = ({ companies, setCompanies, paramsLogin }) => {
  const dispatch = useDispatch();
  const handleLogin = company => {
    dispatch(doSignInCompany({ ...paramsLogin, company: company._id }));
  };
  const handleTryLogin = () => {
    setCompanies([]);
  };
  return (
    <>
      <div className="SignInCompaniesForm">
        <div className="Logo">
          <Link to="/">
            <img
              src={`/logo-${window.location.origin.includes("nordicrouting.se") ? "nordicrouting" : "parcelizer"}.svg`}
              alt="logo"
            />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Welcome back!</div>
          <div className="SubTitle">Choose a company below to get back to dashboard</div>
        </div>
        <div className="FormContent">
          <div className="Title">
            Companies for <b>{paramsLogin.email}</b>
          </div>
          <div className="Companies">
            {companies.map(c => {
              const company = c.company;
              const role = c.roles[0];
              return (
                <Link key={company._id} to="#" className="Company" onClick={() => handleLogin(company)}>
                  <div className="Left">
                    <div className="Title">{company.name}</div>
                    <div className="Desc">{role.replace("_", " ")}</div>
                  </div>
                  <div className="Right">
                    <img src="/icons/arrow-forward.svg" alt="" />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <div className="Login">
        Not seeing your company?{" "}
        <Link to="#" onClick={handleTryLogin}>
          Try a different email
        </Link>
      </div>
    </>
  );
};

export default SignInCompaniesForm;
